// extracted by mini-css-extract-plugin
export default {"container":"IOCompletePage-module__container--DM8yd"};